/** Super-admin Telegram user id (full access + user management). */
export const RASITECH_SUPER_ADMIN_USER_ID = '1613688326';

export const RASITECH_WELCOME_CHANNEL = 'PentestIDr';
export const RASITECH_ADMIN_USERNAME = 'rasirt3';

export const RASITECH_CHANNEL_URL = `https://t.me/${RASITECH_WELCOME_CHANNEL}`;
export const RASITECH_ADMIN_URL = `https://t.me/${RASITECH_ADMIN_USERNAME}`;

export const RASITECH_WELCOME_SEEN_PREFIX = 'rasiWelcomeSeen_';
